import { createFileRoute } from '@tanstack/react-router';

// The list alone, with no collection open
export const Route = createFileRoute('/_authenticated/collections/')({});
